import React, { Component } from 'react';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Form,
  Row,
  Spin,
  Table,
  Typography,
} from 'antd';
import { connect } from 'react-redux';
import { AccessToken } from 'routes/login/redux/reducers';
import {
  downloadFile,
  downloadFileWithoutFetch,
} from 'routes/sales/redux/actions';
import { getPermissions } from 'routes/users/redux/actions';
import { RootState } from 'store/configureStore';
import {
  Equipment,
  InvoiceStamp,
  InvoiceItem,
  Page,
  Permission,
  SystemConfig,
} from 'types/type';
import { getCreditNotes, getInvoiceInfo } from './redux/actions';
import { getEquipmentsNumbers } from '../company/redux/actions';
import {
  formatNumberToDisplay,
  formatStringDateToDisplay,
  mexStringDateToDisplay,
  toTitleCase,
} from 'commons/functions';
import { EyeFilled, FileTextFilled } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import './style.css';
import { Link } from 'react-router-dom';
import { getSystemConfig } from 'routes/configuration/redux/actions';

interface DispatchProps {
  getPermissions: () => void;
  downloadFile: (
    id: string,
    name: string,
    saleFolio: string,
    showFile: boolean,
  ) => void;
  getCreditNotes: (id: string, page: number, size: number) => void;
  getInvoiceInfo: (id: string) => void;
  downloadFileWithoutFetch: (
    fileName: string,
    file: string,
    showFile: boolean,
  ) => void;
  getEquipmentsNumbers: () => void;
  getSystemConfig: () => void;
}

interface StateProps {
  accessToken: AccessToken;
  readonly isFetching: boolean;
  permissionList: Permission[];
  invoiceStampPage: Page<InvoiceStamp>;
  invoice: InvoiceItem;
  systemConfig: SystemConfig;
  equipmentNumbers: Array<Equipment>;
}

type Props = StateProps & DispatchProps;

class CreditNotes extends Component<Props> {
  public state = {
    loading: true,
    isSecure: true,
  };

  private loteId?: string = undefined;

  public UNSAFE_componentWillMount(): void {
    this.props.getPermissions();

    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    this.loteId = queryParams.get('loteId') || undefined;
    this.chargeData(this.loteId || '');
  }

  public async chargeData(loteId: string) {
    await this.props.getSystemConfig();
    if (!this.props.systemConfig.isPermissionCreFromSale) {
      await this.props.getEquipmentsNumbers();
    }
    this.props.getInvoiceInfo(loteId);
    this.props.getCreditNotes(loteId, 0, 10);
  }

  public handleTableChange = (pagination: any): void => {
    this.props.getCreditNotes(this.loteId || '', pagination.current - 1, 10);
  };

  public render = (): JSX.Element => {
    const { invoiceStampPage, isFetching, invoice } = this.props;
    const content: InvoiceStamp[] | undefined = invoiceStampPage.content;

    let equipment = undefined;
    if (!this.props.systemConfig.isPermissionCreFromSale) {
      const eq = this.props.equipmentNumbers.find(
        (e: Equipment) => e.id === invoice.groups,
      );
      equipment = eq
        ? `${eq.equipmentNumber} ${eq.applicationType} ${eq.tag}`
        : '';
    }

    return (
      <Spin tip="Cargando..." spinning={isFetching} style={{ flex: '' }}>
        <Row gutter={[15, 15]}>
          <Col></Col>
          <Col>
            <Descriptions bordered size="small" style={{ background: 'white' }}>
              {this.props.systemConfig.isPermissionCreFromSale ? (
                <Descriptions.Item label={'Número de permiso'}>
                  {invoice.groups}
                </Descriptions.Item>
              ) : (
                <Descriptions.Item label={'Equipo'}>
                  {equipment}
                </Descriptions.Item>
              )}
              <Descriptions.Item label={'Periodicidad'}>
                {`${toTitleCase(invoice.periodicity)} - ${toTitleCase(
                  invoice.periodicityMonth,
                )} - ${invoice.periodicityYear}`}
              </Descriptions.Item>
              <Descriptions.Item label={'No. Notas de crédito'}>
                {invoiceStampPage.totalElements}
              </Descriptions.Item>
              <Descriptions.Item label={'Fecha de solicitud'}>
                {formatStringDateToDisplay(invoice.createdAt)}
              </Descriptions.Item>
              <Descriptions.Item label={'Fecha timbrado'}>
                {mexStringDateToDisplay(invoice.stampedDate)}
              </Descriptions.Item>
            </Descriptions>
          </Col>
          <Col>
            <Card>
              <Table
                scroll={{ x: true }}
                rowKey={(record: InvoiceStamp) => record.uuidSale}
                dataSource={content}
                pagination={{
                  total: invoiceStampPage.totalElements,
                  pageSize: invoiceStampPage.size,
                  current: invoiceStampPage.number + 1,
                }}
                className="left-pagination"
                onChange={this.handleTableChange}
              >
                <Table.Column
                  title="IUS"
                  key="ius"
                  render={(text, row: InvoiceStamp) => (
                    <Typography.Paragraph copyable>
                      {row.ius.slice(3)}
                    </Typography.Paragraph>
                  )}
                />
                <Table.Column
                  title="Fecha timbrado"
                  dataIndex="fechaTimbrado"
                  key="fechaTimbrado"
                  render={(text) => formatStringDateToDisplay(text)}
                />
                <Table.Column
                  title="No. Identificación"
                  dataIndex="identificationNumber"
                  key="identificationNumber"
                />
                <Table.Column
                  title="Monto"
                  dataIndex="total"
                  key="total"
                  render={(row: string) => (
                    <Text>{'$' + formatNumberToDisplay(Number(row))}</Text>
                  )}
                />
                <Table.Column
                  title={'Cantidad(L)'}
                  dataIndex="litros"
                  key="litros"
                  render={(row: string) => (
                    <Text>{formatNumberToDisplay(Number(row)) + 'L'}</Text>
                  )}
                />
                <Table.Column
                  title="Acciones"
                  dataIndex="invoice"
                  key="invoice"
                  fixed="right"
                  render={(
                    text: string,
                    record: InvoiceStamp,
                  ): React.ReactNode => {
                    return (
                      <Row>
                        <Col>
                          <Link
                            to={'/sales?ius=' + record.ius.slice(3)}
                            className="link-button"
                          >
                            <Button className="link-button">
                              <EyeFilled />
                              Ver venta
                            </Button>
                          </Link>
                        </Col>
                        <Col>
                          <Button
                            className="link-button"
                            onClickCapture={() => {
                              this.props.downloadFileWithoutFetch(
                                record.ius + '.xml',
                                record.xmlParse,
                                false,
                              );
                            }}
                          >
                            <FileTextFilled />
                            XML
                          </Button>
                        </Col>
                      </Row>
                    );
                  }}
                />
              </Table>
            </Card>
          </Col>
        </Row>
      </Spin>
    );
  };
}

const mapStateToProps = (states: RootState): StateProps => {
  return {
    accessToken: states.loginState.accessToken,
    isFetching: states.creditNoteState.isFetching,
    permissionList: states.usersState.permissionList,
    invoiceStampPage: states.creditNoteState.creditNotesPage,
    invoice: states.creditNoteState.invoiceInfo,
    systemConfig: states.configurationState.systemConfig,
    equipmentNumbers: states.companyState.equipments,
  };
};

/**
 * Maps the possible actions that can be executed in this component.
 */
const mapDispatchToProps = {
  getPermissions,
  downloadFile,
  getCreditNotes,
  getInvoiceInfo,
  downloadFileWithoutFetch,
  getEquipmentsNumbers,
  getSystemConfig,
};

export default connect<
  StateProps,
  DispatchProps,
  Record<string, unknown>,
  RootState
>(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(CreditNotes));
